var React = require('react');

function ArrowOutInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.04332 2.80098H2.58764V0.891357H12.3202V10.5411H10.4106V4.1345L1.34328 13.1084L0 11.7512L9.04332 2.80098Z","fill":"currentColor"}));
}

ArrowOutInline.defaultProps = {"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none"};

module.exports = ArrowOutInline;

ArrowOutInline.default = ArrowOutInline;
